import { render, staticRenderFns } from "./PreviewNotification.vue?vue&type=template&id=2ce05007&scoped=true&"
import script from "./PreviewNotification.vue?vue&type=script&lang=ts&"
export * from "./PreviewNotification.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewNotification.vue?vue&type=style&index=0&id=2ce05007&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce05007",
  null
  
)

export default component.exports